/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

var par = require("par");
var xtend = require("xtend");

module.exports = Model({
	name: "ownpendingreminders",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_pending: null,
	_reminders: null,
	_localization: null,

	reset: reset,
	refresh: refresh,
	recalculate: recalculate,
});

function init() {
	this._pending = [];
	this._reminders = {};
	this._localization = {};
	this.push([]);
	this.refresh();
}

function uninit() {
	this._pending = null;
	this._reminders = null;
	this._localization = null;
}

function listeners() {
	return {
		"ownreminders:updated": save_reminders_and_recalculate,
		"connectivity:online": refresh,
		"localization:updated": handle_localization_updated,
		"mqtt:$/reminders/history/create": handle_new_item,
		"mqtt:$/reminders/history/update": handle_item_update,
	};
}

function triggers() {
	return {
		"clear": clear_history,
		"view": view,
		"reset": reset
	};
}

function view() {
	this.refresh();
}

function reset() {
	this.push([]);
	this.emit("usermetrics:trigger:track", "close own pending reminders");
}

function refresh() {
	this.api.reminders
		.history.pending()
		.then(save_pending_and_recalculate.bind(this))
		.catch(console.error.bind(console));
}

function recalculate() {
	var nopending = this._pending.length === 0;
	var noPrevious = this.data.length === 0;
	if (nopending && noPrevious) return;

	var merged = this._pending.reduce(par(addpendingIfExists, this._reminders), []);

	var noMerged = merged.length === 0;
	if (noPrevious && noMerged) return;

	this.push(merged);
}

function addpendingIfExists(reminders, result, pending) {
	var reminder = reminders[pending.reminder];
	if (!reminder) return result;
	return result.concat(xtend(pending, {
		reminder: reminder
	}));
}

function save_reminders_and_recalculate(data) {
	var reminders = data.list;
	this._reminders = reminders.reduce(addReminder, {});
	this.recalculate();
}

function addReminder(result, reminder) {
	result[reminder._id] = reminder;
	return result;
}

function save_pending_and_recalculate(pending) {
	var localization = this._localization;
	var lang = localization.language;
	this._pending = pending.map(function (item) {
		item.readable = format_time(item.history.shown, checkLanguage(lang));
		return item;
	});
	this.recalculate();
}

function handle_new_item(history) {
	var item = history;
	item.readable = format_time(history.history.shown);
	this._pending.push(item);
	this.emit("sounds:trigger:play", {
		sound: "alert",
		volume: 1
	});
	this.recalculate();

}

function clear_history(data) {
	var reminder = data.reminder;
	this.api.reminders
		.history.clear(reminder);
	this.emit("usermetrics:trigger:track", "clear own pending reminder", {
		reminder: reminder
	});
}

function handle_item_update(data) {
	var historyId = data._id;

	var filtered = this._pending.filter(function (pending) {
		return pending._id !== historyId;
	});

	if (filtered.length === this._pending.length) return;
	this._pending = filtered;
	this.recalculate();
}

function handle_localization_updated(data){
	this._localization = data;
}

function format_time(datetimegroup, lang) {

	var pending = new Date(datetimegroup);
	var hours = pending.getHours();
	var minutes = pending.getMinutes();

	var readable = pending.toLocaleDateString(lang, getDateOptions()) + " @ " + pad(hours) + ":" + pad(minutes);

	function pad(x) {
		if (x.toString().length < 2) {
			x = "0" + x;
			return x;
		}
		return x;
	}

	return readable;
}

function checkLanguage(lang){
	if(lang === "cn_s")
		return "zh-CN";
	else if(lang === "cn_t")
		return "zh-HK";
	else
		return lang;
}

function getDateOptions(){
	return {
		weekday: "short",
		month: "short",
		day: "2-digit"
	};
}
